import { useEffect, useState } from "react";
import { uniqueId } from "lodash";

type Props = {
  onTrack: (
    b: string,
    a: {
      attemptId: string;
      attemptPath: string;
      [key: string]: any;
    }
  ) => void;
};

type TrackAttemptArgs = {
  event?: string;
  data?: Record<string, unknown>;
  path?: string;
};

export const attemptNodes = {
  cancel: "cancel",
  edit: "edit",
  error: "error",
  load: "load",
  save: "save",
  "select-bank": "select-bank",
  "select-card": "select-card",
  "select-paypal": "select-paypal",
  "switch-bank": "switch-bank",
  "switch-card": "switch-card",
  "switch-paypal": "switch-paypal",
};

export const attemptEvents = {
  cancel: "Track: Cancel Payment Method edit",
  error: "Track: Payment Method Error",
  load: "Track: Load Payment Method",
  save: "Track: Save Payment Method",
  start: "Track: Start Payment Method edit",
  switch: "Track: Switch Payment Method",
};
/**
 * Appends new path on exisiting path (if exists)
 * otherwise just return new path
 */

const getPath = (path: string | undefined, existingPath: string | undefined) =>
  [existingPath, path].filter(Boolean).join(".");
/**
 * Tracks payment method attempt paths
 */

const useAttemptTracking = ({ onTrack }: Props) => {
  const [id, setId] = useState(uniqueId());
  const [path, setPath] = useState(attemptNodes.load); // Track on load

  useEffect(() => {
    onTrack(attemptEvents.load, {
      attemptId: id,
      attemptPath: path,
      screenWidth: window.screen.width,
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const trackAttempt = (data: TrackAttemptArgs) => {
    const newPath = getPath(data.path, path);

    if (newPath !== path) {
      setPath(newPath);
    }

    if (data.event) {
      onTrack(data.event, {
        ...data.data,
        attemptId: id,
        attemptPath: newPath,
      });
    }
  };

  const resetAttempt = () => {
    setId(uniqueId());
    setPath(attemptNodes.load);
  };

  return {
    resetAttempt,
    trackAttempt,
  };
};

export default useAttemptTracking;
